import type { TimeControl } from 'chessboard/api/time-control/config/types';

/**
 * Get the expected game duration.
 */
export function getExpectedGameDuration(timeControl: TimeControl.Model) {
  const { baseTime, increment } = timeControl;

  return (baseTime + 40 * (increment || 0)) / 1000;
}
